import type { LucideIcon } from 'lucide-react';
import { spinIconOut } from '../../../utils/iconAnimations.ts';

export default function AuditKpiCard({
  label, value, Icon, color, sub, subColor,
}: {
  label: string;
  value: number | string;
  Icon: LucideIcon;
  color: string;
  sub?: string;
  subColor?: string;
}) {
  return (
    <div
      className="audit-kpi-card audit-in"
      // Same whole-card-is-the-trigger pattern as Dashboard's .dash-kpi-card: hover anywhere on
      // the card wiggles the .btn-icon in (audit.css), leaving spins it out via the shared handler.
      onMouseLeave={spinIconOut}
      style={{
        display: 'flex', gap: 12, padding: 16, borderRadius: 14,
        background: 'var(--bg-surface)', border: '1px solid var(--border-subtle)',
        borderTop: `3px solid ${color}`,
      }}
    >
      <div
        style={{
          width: 38, height: 38, borderRadius: 10, background: `${color}26`,
          display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}
      >
        <Icon size={18} color={color} strokeWidth={2} className="btn-icon" />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
        <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{label}</div>
        <div style={{ fontSize: 22, fontWeight: 700, lineHeight: 1.15, color: 'var(--text-primary)' }}>{value}</div>
        {sub && <div style={{ fontSize: 11, color: subColor ?? 'var(--text-muted)' }}>{sub}</div>}
      </div>
    </div>
  );
}
